// extracted by mini-css-extract-plugin
module.exports = {"fontFamilyDefault":"var(--font-inter),sans-serif","fontSizeDefault":"16px","fontSizeBody":"16px","fontSizeSmall2":"11px"};